import { useState, useEffect } from "react";

const useCustomLocation = () => {
    const [location, setLocation] = useState({
        search: window.location.search,
    });

    useEffect(() => {
        const checkLocationChange = () => {
            const { search } = window.location;
            setLocation((prev) => {
                if (prev.search !== search) {
                    return { search };
                }
                return prev;
            });
        };

        const interval = setInterval(checkLocationChange, 400); // Check every 400ms

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const url = new URL(window.location.href);
        const variantIdFromLocation = url.searchParams.get("variant");

        if (variantIdFromLocation) {
            try {
                window.ShopifyAnalytics.meta.selectedVariantId = variantIdFromLocation;
            } catch (error) {
                window.ShopifyAnalytics = { meta: { selectedVariantId: variantIdFromLocation } };
            }
        }
    }, [location]);

    return location;
};

export default useCustomLocation;
